<app-dea-dialog-wrapper>
  <div class="fw-semibold text-start fs-4 mb-2">Filtri Films</div>
  <form [formGroup]="formGroup">
    <!-- Languages -->
    <ng-container *ngIf="filtersOptions.languages.length > 0">
      <app-dea-label class="mb-2" label="Lingue:"></app-dea-label>
      <div formArrayName="languages" class="d-flex flex-row justify-content-start flex-wrap gap-2">
        <ng-container *ngFor="let language of filtersOptions.languages; let i = index">
          <mat-checkbox [formControlName]="i" color="primary">
            <div class="no-warp text-uppercase">{{ language }}</div>
          </mat-checkbox>
        </ng-container>
      </div>
    </ng-container>
    <!-- Subtitles -->
    <ng-container *ngIf="filtersOptions.subtitles.length > 0">
      <app-dea-label class="mb-2 mt-3" label="Sottotitoli:"></app-dea-label>
      <div formArrayName="subtitles" class="d-flex flex-row justify-content-start flex-wrap gap-2">
        <ng-container *ngFor="let subtitle of filtersOptions.subtitles; let i = index">
          <mat-checkbox [formControlName]="i" color="primary">
            <div class="no-warp text-uppercase">{{ subtitle }}</div>
          </mat-checkbox>
        </ng-container>
      </div>
    </ng-container>
    <!-- Categories -->
    <ng-container *ngIf="filtersOptions.categories.length > 0">
      <app-dea-label class="mb-2 mt-3" label="Categorie:"></app-dea-label>
      <div formArrayName="categories" class="d-flex flex-row justify-content-start flex-wrap gap-2">
        <ng-container *ngFor="let category of filtersOptions.categories; let i = index">
          <mat-checkbox [formControlName]="i" color="primary">
            <div class="no-warp">{{ category }}</div>
          </mat-checkbox>
        </ng-container>
      </div>
    </ng-container>
  </form>
  <div class="mt-3 gap-2" mat-dialog-actions align="end">
    <div class="py-1 me-auto dea-hover-underline opacity-50" (click)="onReset()">Reset Filtri</div>
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">Annulla</button>
    <button class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()">Filtra</button>
  </div>
</app-dea-dialog-wrapper>